import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';

export const mockNoUserLoggedOut: MockResponseConfig = {
  AtlassianAccountUserQuery: (variables: Variables) => ({
    data: {
      me: {
        user: null,
      },
    },
  }),
};
